// @flow

import * as React from 'react';

import { Base, type DialogStateProps } from '@gandi/ui';

import { ErrorBoundary, sendErrorReport } from 'src/helpers/ErrorBoundary';

import { useSuggestedList } from '../modules/hook';

import { DomainBundle } from './DomainBundle';
import styles from './ProvidedDomainList/ProvidedDomainList.scss';
import { ProvidedRow } from './ProvidedDomainList/ProvidedRow';
import { useDomainBundle } from './modules';

type Props = { phasesDialogState: DialogStateProps };

export function HighLightedSuggestion({
  phasesDialogState,
}: Props): null | React.MixedElement {
  const { highlightedResult } = useSuggestedList();

  const { bundle } = useDomainBundle();
  const hasBundle = bundle?.content.includes(highlightedResult || '');

  if (!highlightedResult) return null;

  return (
    <Base margin="none" padding="none" className={styles.root}>
      <Base
        key={highlightedResult}
        backgroundColor="surface"
        className={hasBundle ? styles.bundle : undefined}
      >
        <ErrorBoundary
          fallback={<ProvidedRow.Error fqdn={highlightedResult} />}
          onError={sendErrorReport}
        >
          <ProvidedRow
            fqdn={highlightedResult}
            phasesDialogState={phasesDialogState}
          />
        </ErrorBoundary>
        {hasBundle && <DomainBundle />}
      </Base>
    </Base>
  );
}
